import { render, staticRenderFns } from "./OmbudsmanForm.vue?vue&type=template&id=5a5e5924&"
import script from "./OmbudsmanForm.vue?vue&type=script&lang=js&"
export * from "./OmbudsmanForm.vue?vue&type=script&lang=js&"
import style0 from "./OmbudsmanForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports